<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-md-2">
      <div class="col-sm-12 col-md-6">
        <b-button variant="info" v-b-modal.addModal>
          <i  class="fas fa-plus" /> Yeni Yönetici Ekle
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class=" float-right">
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-header d-flex justify-content-between align-items-center d-print-none">
              İşlemler
              <b-button-group>
              </b-button-group>
            </h5>
            <div class="table-responsive mb-0" id="data">
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :busy="loading"
                  show-empty
                  striped
              >
                <template v-slot:table-busy>
                  <div class="text-center text-white my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Yükleniyor..</strong>
                  </div>
                </template>
                <template v-slot:empty="">
                  <b-alert show variant="warning">
                    Kayıt bulunamadı.
                  </b-alert>
                </template>
                <template v-slot:cell(group_id)="data">
                  {{data.item.groupDetail.group_name}}
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge v-if="data.item.status" variant="success" @click="changeStatus({status: false, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> AKTİF <i class="class"></i>
                  </b-badge>
                  <b-badge variant="danger" v-else @click="changeStatus({status: true, id: data.item.id})">
                    <i class="ion-ios-refresh"></i> DONDURULDU
                  </b-badge>
                </template>

                <template v-slot:cell(edit)="data">
                  <b-button-group>
                    <b-button @click="editIt(data.item.id)" class="btn-sm" variant="warning" v-b-tooltip:v-b-hover title="Düzenle"> <i class="fas fa-edit"></i> </b-button>
                    <b-button @click="removeIt(data.item.id)" class="btn-sm" variant="danger" v-b-tooltip:v-b-hover title="Sil"> <i class="fas fa-trash"></i> </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddAdmin></AddAdmin>
    <EditAdmin :id="editId"></EditAdmin>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import settingsService from "@/services/settingsService";
import AddAdmin from "@/components/modals/admins/AddAdmin";
import EditAdmin from "@/components/modals/admins/EditAdmin";
export default {
  page: {
    title: "Yöneticiler",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AddAdmin, EditAdmin },
  data() {
    return {
      title: "Yöneticiler",
      items: [
        {
          text: "Anasayfa",
          to: "/"
        },
        {
          text: "Yöneticiler",
          active: true
        }
      ],
      name : '',
      fields: [
        {key: 'id', label: '#ID', sortable: true },
        {key: 'username', label: 'Kullanıcı Adı', sortable: true },
        {key: 'group_id', label: 'Yönetici Grubu', sortable: true },
        {key: 'status', label: 'Durum', sortable: false },
        {key: 'edit', label: '#', sortable: false },
      ],
      id: '',
      editId: '',
      tableData: [],
      totalRows: 0,
      loading: true,
      perPage : 0,
      currentPage: 1,
      refresh: this.$store.getters['getRefresh'],

    };
  },
  methods: {
    editIt(id) {
      this.editId = id
      setTimeout(() => {
        this.$bvModal.show('editModalUser')
      }, 300)
    },
    get() {
      this.loading = true
      this.tableData = []

      settingsService.admins({})
          .then((res) => {
            this.loading = false
            if(res.state){
              this.tableData =  res.data
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    changeStatus(item) {
      settingsService.changeAdminStatus({status: item.status, id: item.id})
          .then((res) => {
            if(res.state){
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'success', title: 'Güncelleme başarılı.', message: ''})
              this.get()
            }else {
              this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    removeIt(id){
      this.$swal({
        title: "Tamamen silinecek, emin misiniz?",
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          settingsService.removeAdmin({id: id})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Silindi.', message: ''})
                  this.$store.dispatch('getRefresh', {withdrawals: true})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })
        }
      })
    },
  },
  created() {
    this.get()
  },
  watch: {
    currentPage: function () {
      this.get()
    },
    refresh: function () {
      if(this.refresh){
        this.get()
        this.$store.dispatch('getRefresh', false)
      }
    },
    '$store.getters.getRefresh': function() {
      this.refresh = this.$store.getters.getRefresh
    }
  }
};
</script>